<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import LoginComponent from '@/components/Auth/Login';
import SignupComponent from '@/components/Auth/Signup';
const uuid = require('uuid');
import firebase from 'firebase/compat/app';
import handyUploader from 'handy-uploader/src/components/handyUploader';

export default {
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Be more descriptive.',
        emailMatch: () => "The email and password you entered don't match",
      },
      orderDays: '',
      selected: null,
      recomendedWeekly: '00',
      recomendedMonthly: '00',
      loginDialog: false,
      continueAddItemAfterLogin: false,
      focus: '',
      signupDialog: false,
      itemName: '',
      location: '',
      dailyFee: '',
      weeklyFee: '',
      monthlyFee: '',
      currentValue: '',
      images: [],
      condition: '',
      minDays: 1,
      allCategories: [
        'Technology',
        'Transportation',
        'Household living',
        'DIY',
        'Exercise',
        'Music and Audio',
      ],
      allConditions: [
        '1 - Damaged',
        '2 - Well used, shows obvious sign of use or aging',
        '3 - Mildy used, starting to show signs of use or aging.',
        '4 - Slighty used, still in perfect condition',
        '5 - Brand New',
      ],
      category: null,
      showLoadingForCreateItem: false,
      area: null,
      max: 500,
      deposit: '',
      itemDescription: '',
      deliveryFee: '',
      handyAttachments: [],
    };
  },
  watch: {
    dailyFee: function (val) {
      this.dailyFee = val;
      this.recomendedWeekly = val * 4;
      this.recomendedMonthly = val * 12;
    },
    enabledDeposit: function () {
      this.enabledDeposit = 'false';
      this.deposit = '';
    },

    user(value) {
      if (value !== null && value !== undefined) {
        if (this.shouldRedirect) {
          this.$router.push('/dashboard');
          this.$emit('loggedIn');
        } else if (this.addItem) {
          this.welcomeDialog = true;
          this.$emit('loggedIn');
        } else {
          this.$emit('loggedIn');
        }
      }
      if (value != null && this.continueAddItemAfterLogin) {
        this.uploadImages();
      }
    },
  },
  components: {
    vueDropzone: vue2Dropzone,
    LoginComponent,
    SignupComponent,
    handyUploader,
  },
  methods: {
    async afterComplete(upload) {
      this.uploaded++;
      //var imageUrl = uuid.v1();
      this.isLoading = true;
      // try {
      //   // save image
      //   const file = this.imageUrls[0];
      //   var metadata = {
      //     contentType: "image/png",
      //   };
      //   var storageRef = firebase.storage().ref();
      //   var imageRef = storageRef.child(`items/${imageUrl}.png`);
      //   await imageRef.put(file, metadata);
      //   var downloadURL = await imageRef.getDownloadURL();
      //   this.images.push({ src: downloadURL });
      // } catch (error) {
      //   console.log(error);
      // }
      // this.$refs.imgDropZone.removeFile(upload)
    },
    async uploadImages() {
      this.showLoadingForCreateItem = true;
      if (!this.userIsAuthenticated()) {
        // TODO
        this.loginDialog = true;
        this.continueAddItemAfterLogin = true;
      } else {
        var files = this.$refs.imgDropZone.getAcceptedFiles();
        var arr = [];
        for (var i in files) {
          arr.push(files[i].dataURL);
        }
        this.imageUrls = arr;

        this.images = new Promise(async (resolve, reject) => {
          var arr = [];
          for (var i in this.imageUrls) {
            var imageUrl = uuid.v1();
            try {
              const file = this.imageUrls[i];
              var metadata = {
                contentType: 'image/png',
              };
              var storage = firebase.storage();
              // storage.useEmulator('localhost', 9199);
              var storageRef = storage.ref();
              var imageRef = storageRef.child(`items/${imageUrl}.png`);
              await imageRef.putString(this.imageUrls[i], 'data_url');
              var downloadURL = await imageRef.getDownloadURL();
              arr.push({ src: downloadURL });
            } catch (error) {
              console.log(error);
            }
          }
        });
      }
    },

    async addItem() {
      var images = await this.images;
      const itemData = {
        itemName: this.itemName,
        location: this.location,
        deposit: this.deposit,
        deliveryFee: this.deliveryFee,
        itemDescription: this.itemDescription,
        dailyFee: this.dailyFee,
        monthlyFee: this.monthlyFee,
        weeklyFee: this.weeklyFee,
        area: this.area,
        images,
        minDays: this.minDays,
        condition: this.condition,
        currentValue: this.currentValue,
        category: this.category,
      };

      this.dialog = true;
      this.$store
        .dispatch('createItem', itemData)
        .then(() => {
          this.showLoadingForCreateItem = false;
          this.successDialog = true;
        })
        .catch((err) => {
          //handle error
          this.showLoadingForCreateItem = false;
        });
      // this.$confetti.start();
    },

    onFilePicked(event) {
      const files = event.target.files;
      for (var i = 0; i < files.length; i++) {
        const filename = files[i].name;
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file!');
        }
        const fileReader = new FileReader();
        fileReader.addEventListener('load', () => {
          this.imageUrls.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[i]);
      }
      console.log(this.imageUrls);
    },
    onPickFile() {
      this.$refs.imgDropZone.click();
    },

    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    userIsLogged() {
      if (!this.userIsAuthenticated) {
        return false;
      } else if (this.userIsAuthenticated) {
        return true;
      }
    },
    userIsNotAuthenticated() {
      return (
        this.$store.getters.user == null &&
        this.$store.getters.user == undefined
      );
    },

    async remove() {
      this.uploaded > 0 ? this.uploaded-- : (this.uploaded = 0);
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    error() {
      return this.$store.getters.error;
    },
    user() {
      return this.$store.getters.user;
    },
    nameProgress() {
      return Math.min(100, this.itemName.length * 10);
    },
    nameColor() {
      return ['error', 'warning', 'success'][
        Math.floor(this.nameProgress / 30)
      ];
    },
    loading() {
      return this.$store.getters.loading;
    },
    progress() {
      return Math.min(100, this.itemDescription.length * 1.6);
    },
    color() {
      return ['red', 'orange', 'green'][Math.floor(this.progress / 40)];
    },
    formIsValid() {
      return this.itemName.length > 5 && this.uploaded !== 0;
    },
  },
};
</script>

<template>
  <div class="d-flex justify-center">
    <v-row style="max-width: 1200px">
      <v-col cols="10" offset="1">
        <v-card color="#F7F7F7" class="pa-3 my-9 px-md-16 py-7 round">
          <p class="text-h4 text-center app--text">New Request</p>
          <v-form @submit.prevent="uploadImages">
            <!-- Images:

            <div class="d-flex flex-wrap justify-center" color="grey lighten-2">
              <v-card style="border-radius: 16px; display:grid; place-items: center;" class=" ma-1" height="10vh" width="8vw" v-for="n in 5" :key="n">
                <v-img :src="
                    require('@/assets/fontawesome/camera-retro-duotone.svg')
                  " height="50%" width="50%" contain alt="Uploaded image" />
              </v-card>
            </div>

            <input type="hidden" role="uploadcare-uploader" data-public-key="37c38b69ee423232f3de" data-tabs="file camera url facebook gdrive gphotos" />
            <br /> -->

            <span>Images</span>
            <br />
            <span class="font-italic"
              >at least 1 image is required, maximum 6</span
            >

            <handy-uploader
              ref="uploader"
              :documentAttachment.sync="handyAttachments"
              :fileUploaderType="'simple'"
              :maxFileSize="10240"
              :imageCompressor="true"
              :imageCompressLevel="0.8"
              :maxFileCount="6"
              :badgeCounter="true"
              :thumb="true"
              :changeFileName="true"
              :addFileDescription="true"
              :addFileTag="true"
              :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
              :btnColor="'#f8b58e'"
              :fontColor="'#FFFF'"
              :cardType="'raised'"
              class="my-10"
            >
            </handy-uploader>

            Listing Name:
            <v-text-field
              v-model="itemName"
              label="Item Name"
              solo
              class="round"
              hint="More than 6 characters"
              persistent-hint
              counter
              name="name"
              placeholder="Start typing..."
            >
            </v-text-field>
            Category:
            <v-select
              v-model="category"
              solo
              :items="allCategories"
              label="Select a Category"
              class="round"
              color="rgb(34, 34, 34)"
            />

            <v-row>
              <v-col>
                Condition:
                <v-select
                  v-model="condition"
                  :items="allConditions"
                  label="item Condition"
                  class="round"
                  solo
                  color="rgb(34, 34, 34)"
                />
              </v-col>
              <v-col>
                Current Value:
                <v-text-field
                  id="value"
                  v-model="currentValue"
                  name="value"
                  label="Rand Value"
                  v-on:keypress="isNumber(event)"
                  class="round"
                  suffix=".00"
                  maxlength="10"
                  solo
                  prefix="R"
                  required
                />
              </v-col>
            </v-row>

            Description:
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-textarea
                  v-bind="attrs"
                  v-on="on"
                  v-model="itemDescription"
                  placeholder="Start typing..."
                  loading
                  color="rgb(34, 34, 34)"
                  type="text"
                  :maxlength="max"
                  required
                  solo
                  hint="between 50 and 500 characters."
                  counter
                  class="round"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      style="border-radius: 12px"
                      :description="progress"
                      :color="color"
                      :value="progress"
                      absolute
                      height="7"
                    />
                  </template>
                  <template v-slot:label>
                    <div>Describe your Item</div>
                  </template>
                </v-textarea>
              </template>
              <span>Minimum of 50 characters needed</span>
            </v-tooltip>

            <v-row>
              <v-col>
                Daily (R):
                <v-text-field
                  class="round"
                  v-model="dailyFee"
                  name="value"
                  v-on:keypress="isNumber(event)"
                  suffix=".00"
                  solo
                  maxlength="12"
                  prefix="R"
                  required
                />
              </v-col>

              <v-col>
                Weekly (R):
                <v-text-field
                  class="round"
                  v-model="weeklyFee"
                  :label="'Weekly Fee should\'nt exceed: R ' + recomendedWeekly"
                  placeholder="00"
                  solo
                  maxlength="12"
                  :disabled="dailyFee == ''"
                  suffix=".00"
                  prefix="R"
                  v-on:keypress="isNumber(event)"
                  required
                />
              </v-col>

              <v-col>
                Monthly (R):
                <v-text-field
                  class="round"
                  :label="
                    'Monthly Fee should\'nt exceed: R' + recomendedMonthly
                  "
                  placeholder="00"
                  label-style="font-weight: bold;"
                  v-model="monthlyFee"
                  :disabled="dailyFee == ''"
                  prefix="R"
                  v-on:keypress="isNumber(event)"
                  required
                  maxlength="10"
                  suffix=".00"
                  solo
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                Minimum rental days:
                <v-text-field
                  v-model="minDays"
                  label="Deposit Amount"
                  v-bind:focus="focus"
                  required
                  placeholder="00"
                  suffix="Days"
                  v-on:keypress="isNumber(event)"
                  class="round"
                  solo
                />
              </v-col>
              <v-col>
                Deposit Amount (leave blank if none):
                <v-text-field
                  v-model="deposit"
                  label="Deposit Amount"
                  prefix="R"
                  required
                  placeholder="00"
                  suffix=".00"
                  v-on:keypress="isNumber(event)"
                  class="round"
                  solo
                />
              </v-col>
            </v-row>

            Delivery Fee Amount (leave blank if none):
            <v-text-field
              label="Delivery Fee"
              v-model="deliveryFee"
              placeholder="00"
              prefix="R"
              class="round"
              v-on:keypress="isNumber(event)"
              solo
            />

            <v-row>
              <v-col>
                Suburb:
                <v-text-field
                  v-model="area"
                  solo
                  prepend-icon="mdi-map-marker"
                  ref="autocomplete"
                  class="round"
                  label="Postal Code"
                  required
                />
              </v-col>

              <v-col>
                Postal Code:
                <v-text-field
                  v-model="location"
                  solo
                  ref="autocomplete"
                  class="round"
                  label="Postal Code"
                  required
                />
              </v-col>
            </v-row>

            <v-btn
              @click="uploadImages()"
              class="ebtn"
              :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
              type="submit"
              rounded
              color="accent"
              elevation="8"
              :loading="showLoadingForCreateItem"
            >
              Submit
            </v-btn>
          </v-form>
        </v-card>
      </v-col>

      <v-overlay v-if="showLoadingForCreateItem">
        <v-img :src="require('@/assets/svgs/gondola2.svg')" />
        Uploading your item...
      </v-overlay>
    </v-row>
  </div>
</template>

<style scoped>
.round {
  border-radius: 12px;
}

.dropzone .dz-preview.dz-image-preview {
  background: white;
  z-index: 2;
}
</style>
